import request from '@/libs/http/index'

export interface UserVoiceSettingResp {
  chargeVoicePromptEnabled: boolean
  dispensingVoicePromptEnabled: boolean
}

export interface UserVoiceSettingUpdateParams {
  scene: 1 | 2
  enabled: boolean
}

export const userVoiceSettingDetail = () => {
  return request.get({
    url: '/clinic/user-voice-setting/get',
  })
}

export const userVoiceSettingUpdate = (data: UserVoiceSettingUpdateParams) => {
  return request.put({
    url: '/clinic/user-voice-setting/update',
    data,
  })
}
